// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contact_wrapper__qqRjF","contact-content":"contact_contact-content__QQiew","bg-logo":"contact_bg-logo__P7ecy"};